import { Outlet } from 'react-router-dom';

import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { Navigate } from './Navigate';

type Props = {
  redirectTo?: string;
};

/**
 * Route wrapper that redirects to the specified path when the current
 * organization is in read-only mode.
 * Use this for routes that should be inaccessible in read-only mode.
 */
export const ReadOnlyProtectedRoute = ({ redirectTo = '/' }: Props) => {
  const isOrganizationReadOnly = useIsOrganizationReadOnly();

  if (isOrganizationReadOnly) {
    return (
      <Navigate
        to={redirectTo}
        state={{
          message: 'This feature is not available in read-only mode.',
        }}
        replace
      />
    );
  }

  return <Outlet />;
};
